export var IInvoice;
(function (IInvoice) {
    let State;
    (function (State) {
        /**
         * The brand order is not shipped yet and can not be paid.
         */
        State["NOT_PAYABLE"] = "NOT_PAYABLE";
        /**
         * The brand order has shipped and can be paid.
         */
        State["UNPAID"] = "UNPAID";
        /**
         * The brand order should be paid but it is not.
         */
        State["OVERDUE"] = "OVERDUE";
        /**
         * The brand order is paid either by regular payment or payment/installment plan.
         */
        State["PAID"] = "PAID";
    })(State = IInvoice.State || (IInvoice.State = {}));
    let PaymentPlanEligibility;
    (function (PaymentPlanEligibility) {
        /**
         * The invoice has no eligible payment plan.
         */
        PaymentPlanEligibility["NONE"] = "NONE";
        /**
         * The invoice can be enrolled into overdue payment plan.
         */
        PaymentPlanEligibility["OVERDUE_ELIGIBLE"] = "OVERDUE_ELIGIBLE";
        /**
         * The invoice can be enrolled into launch with faire payment plan.
         */
        PaymentPlanEligibility["LAUNCH_WITH_FAIRE_ELIGIBLE"] = "LAUNCH_WITH_FAIRE_ELIGIBLE";
    })(PaymentPlanEligibility = IInvoice.PaymentPlanEligibility || (IInvoice.PaymentPlanEligibility = {}));
    let PaymentStatusTextType;
    (function (PaymentStatusTextType) {
        PaymentStatusTextType["ALARM"] = "ALARM";
        PaymentStatusTextType["NORMAL"] = "NORMAL";
    })(PaymentStatusTextType = IInvoice.PaymentStatusTextType || (IInvoice.PaymentStatusTextType = {}));
    let IPaymentStatusData;
    (function (IPaymentStatusData) {
        /**
         * Return an instance of IPaymentStatusData with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IPaymentStatusData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IPaymentStatusData = IInvoice.IPaymentStatusData || (IInvoice.IPaymentStatusData = {}));
    /**
     * Return an instance of IInvoice with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IInvoice.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IInvoice || (IInvoice = {}));
